export const STOCK_COUNT_TIME_ZONE = "America/Argentina/Buenos_Aires";

const stockCountDateFormatter = new Intl.DateTimeFormat("es-AR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: STOCK_COUNT_TIME_ZONE,
});

const stockCountDateTimeFormatter = new Intl.DateTimeFormat("es-AR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: STOCK_COUNT_TIME_ZONE,
});

export function formatStockCountDate(value) {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : stockCountDateFormatter.format(date);
}

export function formatStockCountDateTime(value) {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : stockCountDateTimeFormatter.format(date);
}

export function formatCounterCompletion(completedAt) {
  return completedAt
    ? formatStockCountDateTime(completedAt)
    : "Pendiente de conteo";
}

export function formatAuditorCompletion(completedAt) {
  return completedAt
    ? formatStockCountDateTime(completedAt)
    : "Pendiente de auditoría";
}
